import {PremisesParameters, getPremises, getAllPremises} from '../premises';
import {getCalibrationUnits} from '../calibration';
import {getCountryRegions} from '../geo';
import {getGatewayInformation} from '../registration';
import {getCabinetsData, CabinetParameters, resetSensorStore,resetSensorUIStore} from "../cabinets";

/**
 * Callback: when the premises page is loaded in react router
 */
export function onPremisesLoad(store: Redux.Store, params, query) {
    let parameters: PremisesParameters = {};
    if (query.page) {
        parameters.page = query.page;
    }
    if (query.selectedRegion) {
        parameters.region = query.selectedRegion;
    } else if (query.selectedCountry) {
        parameters.region__country = query.selectedCountry;
    }
    store.dispatch(getPremises(parameters));
    store.dispatch(getCountryRegions({has_units: true}));
}

/**
 * Callback: when cabinet details page is loaded
 *
 * @param store
 * @param params
 * @param query
 */
export function onCabinetLoad(store: Redux.Store, params, query) {
    store.dispatch(resetSensorStore());
    store.dispatch(resetSensorUIStore());
    let parameters: CabinetParameters = {
        standalone: true
    };
    if (query.store_slug) {
        parameters.gateway__premises__slug = query.store_slug;
    }
    if (query.page) {
        parameters.page = query.page;
    }
    if (query.selectedRegion) {
        parameters.gateway__premises__region = query.selectedRegion;
    } else if (query.selectedCountry) {
        parameters.gateway__premises__region__country = query.selectedCountry;
    }
    store.dispatch(getAllPremises({disable_alarm_count:true}));
    store.dispatch(getCabinetsData(parameters));
    if (store.getState().data.countries.sortedByName.length == 0){
        store.dispatch(getCountryRegions({has_units: true}));
    }
}

/**
 * Callback: when premises registration page is loaded
 *
 * @param store
 * @param params
 * @param query
 */
export function onRegistrationLoad(store: Redux.Store, params, query) {
    store.dispatch(getCountryRegions());
    store.dispatch(getGatewayInformation(params));
}

/**
 * Callback: when calibration page is loaded
 *
 * @param store
 * @param params
 * @param query
 */
export function onCalibrationLoad(store: Redux.Store, params, query) {
    store.dispatch(getAllPremises({disable_alarm_count: true}));
    store.dispatch(getCalibrationUnits());
}

